import React from 'react';
import { TableRow, TableCell, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import Currency from '../../../../../commonModules/Currency';

const ConfirmFormTemplate = ({ fieldList, transfer, client, sale }) => {
const PRODUCTS = useSelector((state) => state.inventory.products);

	return (
		<>
			{fieldList.map(field => {
				if (client && client[field.name]) {
					return (
						<TableRow key={field.name}>
							<TableCell>{field.label}</TableCell>
							<TableCell colSpan={sale ? 2 : 1}>{field.display}</TableCell>
						</TableRow>
					);
				} else if (transfer && transfer[field.name]) {
					if (field.name === "products") {
						return transfer.products.map(prod => (
						<TableRow key={prod.product_id}>
							<TableCell>
								{PRODUCTS && PRODUCTS[prod.product_id] && PRODUCTS[prod.product_id].photos &&
									<img
										id={PRODUCTS[prod.product_id].photos[0].filename}
										src={`/stocks/photos/${PRODUCTS[prod.product_id].photos[0].filename}`}
										style={{ height: "100px", maxWidth: 'none', width: 'auto' }}
										alt="Product"
									/>
								}
							</TableCell>
							<TableCell>
								<Typography color="secondary" variant="h6"><b>{prod.quantity} x</b></Typography>
								<Typography variant="button"><b>{prod.display.label}</b></Typography>
							</TableCell>
							{prod.priceTotal &&
								<TableCell>
									<Typography variant="body1"><b><Currency value={prod.priceTotal}/></b></Typography>
								</TableCell>
							}
						</TableRow>
						));
					} else if (field.name == "totalArt") {
						return (
							<TableRow>
								<TableCell>
									<Typography color="secondary" variant="h6">
										<b>Total Articles</b>
									</Typography>
								</TableCell>
								<TableCell colSpan={sale ? 2 : 1}>
									<Typography color="secondary" variant="h6">
										<b>{transfer.products.reduce((acc, product) => acc + parseInt(product.quantity), 0)}</b>
									</Typography>
								</TableCell>
							</TableRow>
						)
					
					} else {
						return (
							<TableRow key={field.name}>
								<TableCell>{field.label}</TableCell>
								<TableCell colSpan={sale ? 2 : 1}>{field.display}</TableCell>
							</TableRow>
						);
					}
				}
				return null;
			})}
		</>
	);
};

export default ConfirmFormTemplate;
